import axios from './index';

export const getReportsRequest = (values) =>
  axios.get(
    `/v1/admins/reports/get/summary/${values?.vendorID || '-'}/${values?.from || '-'}/${
      values?.to || '-'
    }/${values?.busID || '-'}/${values?.deviceID || '-'}`
  );
